module.exports = __webpack_public_path__ + "img/004.3141d9a4.png";